import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Failure = () => {
  const navigate = useNavigate();
  const [counter, setCounter] = useState(1);
  let countInterval = null;

  useEffect(() => {
    countInterval = setInterval(() => setCounter((prev) => prev - 1), 1000);

    return () => {
      if (countInterval) clearInterval(countInterval);
    };
  }, []);

  useEffect(() => {
    if (counter === 0) {
      navigate("/home");
      clearInterval(countInterval);
    }
  }, [counter]);

  return (
    <div>
      <h1>Transaction Failed!</h1>
    </div>
  );
};

export default Failure;
